<template>
    <tr class="dashboard__list_enrolments_table_item">
        <td class="dashboard__list_enrolments_table_item_name">
            {{ courseName }}
        </td>
        <template v-if="!loggedInUserWorkspaceId">
            <td class="dashboard__list_enrolments_table_item_workspacename">
                {{ courseWorkspaceName }}
            </td>
        </template>
        <td class="dashboard__list_enrolments_table_item_enrolmentdate">
            {{ courseEnrolmentDate }}
            <div class="dashboard__list_enrolments_table_item_enrolmentdate_time">
                <component-text :size="'tiny'">Time: {{ courseEnrolmentTime }}</component-text>
            </div>
        </td>
        <template v-if="name === 'dashboard-list-completions-courses' || name === 'lms-superadmin-users-profile-edit-learning-history-courses'">
            <td class="dashboard__list_enrolments_table_item_completiondate">
                <template v-if="courseCompletedDate && courseCompletedTime">
                    {{ courseCompletedDate }}
                    <div class="dashboard__list_enrolments_table_item_completiondate_time">
                        <component-text :size="'tiny'">Time: {{ courseCompletedTime }}</component-text>
                    </div>
                </template>
            </td>
        </template>
        <td class="dashboard__list_enrolments_table_item_state">
            <div class="columns">
                <div class="column is-narrow">
                    <component-status v-if="courseEnrolmentStatus" :status="courseEnrolmentStatus"/>
                </div>
            </div>
        </td>
        <template v-if="name !== 'dashboard-list-completions-courses'">
            <td class="dashboard__list_enrolments_table_item_progress">
                <div class="columns is-vcentered">
                    <div class="column is-narrow">
                        <component-text :size="'medium'">{{ courseNumberOfCompletedModules }} / {{ courseNumberOfModules }}</component-text>
                    </div>
                </div>
            </td>
        </template>
        <td class="dashboard__list_enrolments_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <template v-if="(name === 'dashboard-list-completions-courses' || name === 'lms-superadmin-users-profile-edit-learning-history-courses') && courseCertificateUrl">
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            :name="'dashboard-list-enrolments-table-item-actions-certificate'"
                            :icon="true"
                            :icon-name="'award'"
                            @click="courseCertificateDownload"
                        ></component-button>
                    </div>
                </template>
                <div class="column is-narrow">
                    <component-button
                        :theme="'default'"
                        :name="'dashboard-list-enrolments-table-item-actions-switch'"
                        :disabled="courseWorkspaceId !== loggedInUserWorkspaceId && user.isInpersonated()"
                        :hint="courseWorkspaceId !== loggedInUserWorkspaceId && user.isInpersonated() ? `You can't access the course \n from this workspace` : ''"
                        :align="'right'"
                        @click="handleRedirectToCourse"
                    >Access
                    </component-button>
                </div>
                <template v-if="name === 'lms-superadmin-users-profile-edit-learning-history-courses'">
                    <div class="column is-narrow">
                        <component-button
                            :name="'dashboard-list-enrolments-table-item-actions-collapse'"
                            :icon="true"
                            :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                            :theme="'default'"
                            @click="performEmit('emit-collapse', index)"
                        />
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentText from '@/components/default/shared/ComponentText'
import { User } from '@/User'

export default {
  name: 'dashboard-list-enrolments-table-item',
  components: { ComponentText, ComponentButton, ComponentStatus },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    name: {
      type: String
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    courseId () {
      return this.item.courseId
    },
    courseName () {
      return this.item.courseName
    },
    courseVersionId () {
      return this.item.courseVersionId
    },
    courseWorkspaceId () {
      return this.item.workspaceId
    },
    courseWorkspaceName () {
      return this.item.workspaceName
    },
    courseCatalogId () {
      return this.item.catalogItemId
    },
    courseEnrolmentStatus () {
      return this.item.enrolmentStatus
    },
    courseEnrolmentId () {
      return this.item.enrolmentId
    },
    courseNumberOfModules () {
      return this.item.numberOfModules || 0
    },
    courseNumberOfCompletedModules () {
      return this.item.numberOfCompletedModules || 0
    },
    courseCompletion () {
      return this.item.completion
    },
    courseEnrolmentTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.enrolmentDateTime || this.item.enrolmentDate))
    },
    courseEnrolmentDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.enrolmentDateTime || this.item.enrolmentDate))
    },
    courseCompletedTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.completedAt || this.item.completionDate))
    },
    courseCompletedDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.completedAt || this.item.completionDate))
    },
    courseCertificateUrl () {
      return this.item.certificateUrl || ''
    },
    //
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    }
  },
  methods: {
    courseCertificateDownload () {
      this.$store.dispatch('ebsCertificateDownload', { name: this.courseName, url: this.courseCertificateUrl })
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    handleSwitchWorkspaceRedirect (to) {
      const loggedInUserWorkspaceId = this.loggedInUserWorkspaceId
      const courseWorkspaceId = this.courseWorkspaceId

      if (loggedInUserWorkspaceId !== courseWorkspaceId) {
        this.$store.dispatch('authUserLoginSSOWorkspace', courseWorkspaceId).then(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `Your workspace has been switched.`,
            status: 'success'
          })
          this.$router.push(to)
        }).catch(() => {
          this.$store.dispatch('defaultNotificationToastsAdd', {
            title: 'Session redirect',
            message: `You can't be redirected to the course due to issues with switching workspace.`,
            status: 'error'
          })
        })
      } else {
        this.$router.push(to)
      }
    },
    handleRedirectToCourse () {
      if (this.name === 'dashboard-list-completions-courses') {
        this.handleSwitchWorkspaceRedirect({ name: 'ebs-course-enrolment-show', params: { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId, enrolmentId: this.courseEnrolmentId } })
      } else {
        this.handleSwitchWorkspaceRedirect({ name: 'ebs-course-version-show', params: { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId } })
      }
    }
  }
}
</script>
